"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegerSanitizer = void 0;
var IntegerSanitizer = /** @class */ (function () {
    function IntegerSanitizer() {
    }
    IntegerSanitizer.prototype.format = function (value) {
        if ('' === value || value === undefined) {
            return '';
        }
        return Math.round(parseFloat(value)).toString();
    };
    IntegerSanitizer.prototype.sanitize = function (value) {
        var nValue = value.replace(/^0?[^0-9]*/g, '');
        if ('' === nValue) {
            return 0;
        }
        return parseFloat(nValue);
    };
    IntegerSanitizer.prototype.blockUnallowedCharacters = function (value) {
        return value.replace(/^0?[^0-9]*/g, '');
    };
    return IntegerSanitizer;
}());
exports.IntegerSanitizer = IntegerSanitizer;
//# sourceMappingURL=IntegerSanitizer.js.map